import { Tile, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ContactInformation from '../ContactInformation';
import { StyledLinePrompt, StyledP } from './TechnicalSupportTile.styles';
import { ContactUs } from '../interfaces/ContactUs';
import { ContactUsResourceInfo } from '../ContactUsResource/ContactUsResource';

export interface TechnicalSupportTileProps { }

const TechnicalSupportTile: FC<TechnicalSupportTileProps> = () => {
  const { t } = useTranslation('ContactUsPage');
  const data: ContactUs = useScopedSelector(ContactUsResourceInfo.dataDst);
  if (!data?.technicalSupport) return null;

  return (
    <Tile data-testid="technicalSupportTile" titleAs="h2" title={t('technicalSupportTitle')}>
      <ContactInformation contact={data?.technicalSupport?.contact} />
      {data?.technicalSupport?.contact?.email && <StyledLinePrompt> {t('emailPrompt')} </StyledLinePrompt>}
      {data?.technicalSupport?.informations ? <StyledP>{data.technicalSupport.informations}</StyledP> : null}
    </Tile>
  );
};

export default TechnicalSupportTile;
